import {
  GetCancellationRulesRequest,
  GetPropertyByIdRequest,
  GetRoomsByPropertyIdRequest,
  PropertyApi,
  SearchPropertiesByFilterRequest,
} from '@/api/generated/fetch-client';
import { WithSignal } from '@/types/typings';

export class AccommodationApi {
  constructor(private readonly propertyApi: PropertyApi) {}

  async getCancellationRules(requestParameters: WithSignal<GetCancellationRulesRequest>) {
    const { signal, ...args } = requestParameters;
    return this.propertyApi.getCancellationRules(args, { signal });
  }

  async searchPropertiesByFilter(
    requestParameters: WithSignal<SearchPropertiesByFilterRequest>,
  ) {
    const { signal, ...args } = requestParameters;
    return this.propertyApi.searchPropertiesByFilter(args, { signal });
  }

  async getPropertyById(requestParameters: WithSignal<GetPropertyByIdRequest>) {
    const { signal, ...args } = requestParameters;
    return this.propertyApi.getPropertyById(args, { signal });
  }

  async getRoomsByPropertyId(requestParameters: WithSignal<GetRoomsByPropertyIdRequest>) {
    const { signal, ...args } = requestParameters;
    return this.propertyApi.getRoomsByPropertyId(args, { signal });
  }
}
